import { useEffect, type ReactNode } from "react";
import { usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
export function LocaleSync({ children }: { children: ReactNode }) {
  const locale = usePage().props.i18n.locale;
  const { i18n } = useTranslation();
  useEffect(() => {
    void i18n.changeLanguage(locale);
    document.documentElement.lang = locale;
  }, [i18n, locale]);
  return children;
}
